import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ProjectCard from './ProjectCard';
import ProjectModal from './ProjectModal';

const Projects = ({ projects, onUpdateProjects }) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [activeTab, setActiveTab] = useState('live');
  const [projectsData, setProjectsData] = useState({
    live: [],
    completed: []
  });

  useEffect(() => {
    // Ensure we always have both properties as arrays
    if (projects) {
      setProjectsData({
        live: Array.isArray(projects.live) ? projects.live : [],
        completed: Array.isArray(projects.completed) ? projects.completed : []
      });
    }
  }, [projects]);

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <h2>Our Projects</h2>
          <p className="section-intro">
            Explore our ongoing and completed infrastructure projects across the Kingdom of Bahrain.
          </p>

          <div className="projects-tabs">
            <button 
              className={activeTab === 'live' ? 'active' : ''}
              onClick={() => setActiveTab('live')}
            >
              Live Projects
            </button>
            <button 
              className={activeTab === 'completed' ? 'active' : ''}
              onClick={() => setActiveTab('completed')}
            >
              Completed Projects
            </button>
          </div>

          <div className="projects-grid">
            {projectsData[activeTab]?.length === 0 ? (
              <div className="no-projects">
                <p>No {activeTab} projects available.</p>
              </div>
            ) : (
              projectsData[activeTab]?.map((project, index) => (
                <ProjectCard
                  key={project._id || index}
                  project={project}
                  index={index}
                  onClick={() => setSelectedProject(project)}
                />
              ))
            )}
          </div>
        </motion.div>
      </div>

      <AnimatePresence>
        {selectedProject && (
          <ProjectModal
            project={selectedProject}
            onClose={() => setSelectedProject(null)}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default Projects;